<template>
  <el-row class="tac">
    <el-col :span="24">
      <el-menu
        class="el-menu-vertical-demo"
        router
        unique-opened
        @open="handleOpen"
        @close="handleClose"
        background-color="#034C6A"
        text-color="#E6E6E6"
        active-text-color="#ffd04b">
        <template v-for="(item, index) in items">
          <el-submenu v-if="item.items" :index="'menu-' + index" :key="'menu-' + index">
            <template slot="title">
              <i class="fa" :class="item.icon"/>
              <span v-text="item.text"></span>
            </template>
            <el-menu-item-group class="over-hide" v-for="(sub, i) in item.items" :key="'menu-' + index + '-' + i">
              <el-menu-item :index="sub.path" >
                <i class="fa" :class="sub.icon"/>
                <span slot="title">{{sub.text}}</span>
              </el-menu-item>
            </el-menu-item-group>
          </el-submenu>
          <el-menu-item v-else :index="item.path" :key="'menu-' + index">
            <i class="fa" :class="item.icon"/>
            <span slot="title">{{item.text}}</span>
          </el-menu-item>
        </template>
      </el-menu>
    </el-col>
  </el-row>
</template>

<style scoped>
  .over-hide{
    overflow: hidden;
  }
  .el-menu-item-group {
    height: 40px;
    line-height: 20px;
  }
  .el-menu-item {
    height: 40px;
    line-height: 20px;
  }
  i.fa {
    padding-right: 5px;
    width: 16px;
    color: #F5F5F5;
  }
</style>

<script>
  import HomeApi from '@/api/home'
  import Utils from '@/utils/utils'
  import { PERMITS } from '@/cfg'

  export default {
    created() {
      if (this.$store.state.menuItems != undefined) {
        this.items = this.$store.state.menuItems
        return
      }

      const permits = this.$store.getters.loginInfo.permits
      const newItems = []
      this.allMenus().forEach(v => {
        if (v.items == undefined) {
          if (Utils.getBit(permits, v.auth) || v.auth == PERMITS.公共权限) newItems.push(v)
        } else {
          let g = undefined
          v.items.forEach(sub => {
            if (Utils.getBit(permits, sub.auth) || sub.auth == PERMITS.公共权限) {
              if (g == undefined) g = { ...v, items: []}
              g.items.push(sub)
            }
          })
          if (g != undefined) newItems.push(g)
        }
      })
      this.items = newItems
      this.$store.commit('updateMenuItems', newItems)
    },
    //async mounted() {
      //if (this.inited != undefined) {
      //  await this.inited
      //  delete this.inited
      //}
    //},
    data () {
      return {
        items: []
    }},
    methods: {
      handleOpen (key, keyPath) {
        //console.log(key, keyPath)
      },
      handleClose (key, keyPath) {
        //console.log(key, keyPath)
      },
      allMenus () { return [
        //{ icon: 'fa-home', text: '首页', path: '/', auth: PERMITS.公共权限 },
        //{ icon: 'fa-desktop', text: '实时监控', path: '/desktop' },
        //{ icon: 'fa-fire-extinguisher', text: '智慧消防栓' , path: '/a1'},
        /* { icon: 'fa-binoculars', text: '警情信息', path: '/alerts', auth: PERMITS.警情管理 },
        { icon: 'fa-camera', text: '警情统计', path: '/alertStatistics', auth: PERMITS.警情管理 },
        { icon: 'fa-magic', text: '出警统计', path: '/presentStatistics', auth: PERMITS.警情管理 },
        { icon: 'fa-user', text: '在线终端信息', path: '/onlineTerminates', auth: PERMITS.用户管理 },
        { icon: 'fa-share-alt', text: '国家队', path: '/units?unitType=1', auth: PERMITS.单位管理 },
        { icon: 'fa-shirtsinbulk', text: '城市专职', path: '/units?unitType=6', auth: PERMITS.单位管理 },
        { icon: 'fa-slack', text: '乡镇专职', path: '/units?unitType=2', auth: PERMITS.单位管理 },
        { icon: 'fa-shirtsinbulk', text: '企业专职', path: '/units?unitType=3', auth: PERMITS.单位管理 },
        { icon: 'fa-vine', text: '微站管理', path: '/units?unitType=4', auth: PERMITS.单位管理 },
       // { icon: 'fa-inbox', text: '烟感信息', path: '/units?unitType=5', auth: PERMITS.单位管理 },
        { icon: 'fa-bolt', text: '一警六员', path: '/users2' , auth: PERMITS.用户管理 },
        { icon: 'fa-inbox', text: '安全码', path: '/safe-codes', auth: PERMITS.用户管理 },
        
        { icon: 'fa-history', text: '重要公告', path: '/board2s', auth: PERMITS.公告管理 },
        /* { icon: 'fa-street-view', text: 'APP消息管理', path: '/app-msgs', auth: PERMITS.公告管理 }, */
        { icon: 'el-icon-location-outline', text: '系统首页', path: '/', auth: PERMITS.水源管理 },
        { icon: 'fa-street-view', text: '水源统计', path: '/waterStatistics', auth: PERMITS.水源管理 },
        { icon: 'el-icon-location-outline', text: '水源管理', path: '/waterSource', auth: PERMITS.水源管理 },
        { icon: 'el-icon-setting', text: '维修管理', path: '/waterFault', auth: PERMITS.水源管理 },
        
        { icon: 'fa-slack', text: '单位管理', path: '/units', auth: PERMITS.单位管理 },
        { icon: 'fa-user', text: '用户管理', path: '/users', auth: PERMITS.用户管理 },
        
        // { icon: 'el-icon-goods', text: '预案管理', auth: PERMITS.预案管理,
        //  items: [
        //   {icon: 'el-icon-document', text: '单位管理', path: '/index', auth: PERMITS.单位管理},
        //   {icon: 'el-icon-check', text: '预案审核', path: '/checkPlan', auth: PERMITS.预案审核},
        //  { icon: 'el-icon-star-on', text: '处置要点', path: '/keyPoint', auth: PERMITS.处置要点 },
        // { icon: 'el-icon-tickets', text: '单位性质', path: '/unitNature', auth: PERMITS.单位性质 },
        // { icon: 'el-icon-sort', text: '使用性质', path: '/category', auth: PERMITS.使用性质 },
        // { icon: 'el-icon-warning', text: '危化品管理', path: '/dangers', auth: PERMITS.危化品管理 },
        //  ]
        // },
        // },
        { icon: 'fa-bell', text: '故障告警', path: '/waterSourceAlert', auth: PERMITS.水源管理 },
        { icon: 'fa-server', text: '水压监测设备', path: '/iot', auth: PERMITS.水源管理 },
        //{ icon: 'fa-street-view', text: '公告管理', path: '/boards', auth: PERMITS.公告管理 },
        
        // { icon: 'fa-car', text: '巡检统计', path: '/alertStatistics', auth: PERMITS.单位管理 },
        // { icon: 'fa-bell', text: '巡检提醒', path: '/warnAlert', auth: PERMITS.单位管理 },
        // { icon: 'el-icon-info', text: '消防设施', path: '/facilityCategory', auth: PERMITS.消防设施 },
        // { icon: 'el-icon-document', text: '重点单位', path: '/checkedUnit', auth: PERMITS.单位管理 },
        { icon: 'fa-street-view', text: '公告管理', path: '/boards', auth: PERMITS.公告管理 },
        // { icon: 'fa-history', text: '重要公告', path: '/board2s', auth: PERMITS.公告管理 },
        // { icon: 'el-icon-edit-outline', text: '车辆管理', path: '/car', auth: PERMITS.车辆管理 },
        { icon: 'fa-user-plus', text: '日志管理', path: '/log', auth: PERMITS.公告管理 },
        
        { icon: 'fa-snowflake-o', text: '水源分类管理', path: '/waterDicts', auth: PERMITS.系统配置 },
        { icon: 'fa-snowflake-o', text: '接口授权码管理', path: '/codeDicts', auth: PERMITS.系统配置 },
        // { icon: 'fa-user', text: '队伍台账', path: '/member', auth: PERMITS.用户管理 },
        // { icon: 'fa-server', text: '值班管理', path: '/dutyManage', auth: PERMITS.用户管理},
        // { icon: 'fa-server', text: '请假/审批', path: '/applyAndApproval' ,auth: PERMITS.公共权限},
        // { icon: 'fa-server', text: '外出报备', path: '/report' ,auth: PERMITS.公共权限},
        // { icon: 'fa-server', text: '出入管理', path: '/accessControl' ,auth: PERMITS.用户管理},
       { icon: 'fa-user-o', text: '角色管理', path: '/roles', auth: PERMITS.角色管理 },
        { icon: 'fa-snowflake-o', text: '字典管理', path: '/dicts', auth: PERMITS.系统配置 },
        { icon: 'fa-plug', text: '权限定义', path: '/permit-items', auth: PERMITS.系统配置 },
        { icon: 'fa-sitemap', text: '权限路径', path: '/permit-urls', auth: PERMITS.系统配置 },
        { icon: 'fa-server', text: '配置管理', path: '/configs', auth: PERMITS.系统配置 },
       
      ]},
    }
  }
</script>


// WEBPACK FOOTER //
// src/layouts/navmenu.vue